export const headerUrl = {
    consumerLink: 'https://www.maxis.com.my/home',
    businessSMELink: 'https://www.business.maxis.com.my/en/SME/',
    businessCorporateLink: 'https://www.business.maxis.com.my/en/Corporate/',
    hotlinkLink: 'https://www.hotlink.com.my/en/home',
    businessHubLink: 'https://businesshub.maxis.com.my/auth/sso',
}